const category = [
    {
        display: 'Áo thun',
        categorySlug: 'ao-thun',
        gender: 'nam, nu',
    },
    {
        display: 'Áo sơ mi',
        categorySlug: 'ao-somi',
        gender: 'nam, nu',
    },
    {
        display: 'Quần jean',
        categorySlug: 'quan-jean',
        gender: 'nam, nu',
    },
    {
        display: 'Quần tây',
        categorySlug: 'quan-tay',
        gender: 'nam, nu',
    },
    {
        display: 'Váy',
        categorySlug: 'vay',
        gender: 'nu',
    },
];

export default category;
